import { FedexCheckInput } from '@/dto/fedexCheck.input'
import { xhrClient } from '@/config/axiosClient'

const postFedexCheckQuery = async (payload: FedexCheckInput) => {
    const { data } = await xhrClient.post(
        `/api/available-fedex-shipping-methods`,
        payload
    )
    return data
}

export default postFedexCheckQuery
